import type { RefObject } from "react";
import type { OctraceClient } from "@advanced-sales-technologies/octrace-client";
import type { useLogto } from "@logto/react";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

type RouterContext = {
  auth: RefObject<ReturnType<typeof useLogto>>;
  apiClient: RefObject<OctraceClient>;
};

export const Route = createRootRouteWithContext<RouterContext>()({
  errorComponent: () => (
    <div>
      <h1>Something went wrong</h1>
      <p>Please try again later.</p>
    </div>
  ),
  component: () => (
    <>
      <Outlet />
      <TanStackRouterDevtools />
      <ReactQueryDevtools />
    </>
  ),
});
